import { FETCH_MTOKNA_NEWSLETTERS, CLEAN_MTOKNA_NEWSLETTERS, DELETE_MTOKNA_NEWSLETTER } from '../actions/types';

const MTOKNA_NEWSLETTERS_DEFAULT_STATE = {};

/**
 * Reducer pre sablony.
 */
const MtoknaNewslettersReducer = (state = MTOKNA_NEWSLETTERS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_MTOKNA_NEWSLETTERS:
            return payload;

        case CLEAN_MTOKNA_NEWSLETTERS:
        case DELETE_MTOKNA_NEWSLETTER:
            return MTOKNA_NEWSLETTERS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default MtoknaNewslettersReducer;
